<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <mat-label>
    {{'general.resourceStatistic' | transloco}}
  </mat-label>
  <div class="dlg-drag-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div>
</h1>

<div class="resource-dashboard">
  <div class="chart-wrapper">
    <ngx-charts-bar-vertical
      [scheme]="colorScheme"
      [showXAxisLabel]="false"
      [showYAxisLabel]="true"
      [xAxis]="false"
      [yAxis]="true"
      [legend]="true"
      [barPadding]="24"
      [showDataLabel]="true"
      [roundEdges]="false"
      [results]="resourceStatistics"
      [legendTitle]="'Resource'">
    </ngx-charts-bar-vertical>
  </div>

  <div>
    <div class="chart-wrapper">
      <ngx-charts-advanced-pie-chart
        [scheme]="colorScheme"
        [results]="dataStoragePercent"
        [gradient]="false"
        [animations]="false"
        [tooltipDisabled]="true"
        [percentageFormatting]="formatPercentStorageValue"
        [label]="'Total Storage'"
        [valueFormatting]="formatStorageValue">
      </ngx-charts-advanced-pie-chart>
    </div>


    @if (requireAccountUpgrade) {
      <div class="d-flex-center">
        <div style="font-weight: bold;">
          {{'general.maxStorage' | transloco}}
        </div>
        <button mat-raised-button (click)="upgrade()" color="primary" style="margin-left: 20px;">
          <mat-icon style="color: red">rocket_launch</mat-icon>
          upgrade
        </button>
      </div>
    }
  </div>
</div>
